import ServiceGo from 'vuex-live-service-api';
import { Api } from 'vuex-skin-generator-service-api';
import axios from 'axios';

export const service_Go = new ServiceGo ({
    baseURL:window.process.env.API_HOST_LIVE,
    token:process.env.API_GO_LIVE_TOKEN,
});

const clientName = window.process.env.CLIENT_NAME;


export function service(options) {
  let baseUrl =window.process.env.API_HOST_LIVE;
  let headers = {
    'Content-Type': 'application/json',
    Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' +process.env.API_GO_TOKEN,
  };
  if (options) {
    headers['X-Tenant-USER'] = options;
  }
  let baseApiParams = {
    credentials: 'same-origin',
    headers: headers,
    // redirect: 'follow',
  };

  return new Api({
    baseUrl: baseUrl,
    baseApiParams: baseApiParams,
  });
}
export const HTTP_STREAMING = axios.create({
  baseURL: window.process.env.G_STREAMER_HOST,
  headers: {
      "Content-Type": "application/json",
  }
});
export const HTTP_STREAMING_RECORD = axios.create({
  baseURL: window.process.env.G_STREAMER_HOST,
  headers: {
      "Content-Type": "application/json",
      Authorization: "Basic ZW1wcmVpbnRlLWFjY2Vzcy10b2tlbg==",

  }
});
export var API_G_STREAMER={

  stopGStreamer : function (data) {
      var promise = {};
      promise = HTTP_STREAMING.post('live/stop',data)
      return promise;
  },
  stopRecordGStreamer : function (data,isDvr) {
    var promise = {};
    promise = HTTP_STREAMING_RECORD.post(`v1/vhosts/default/apps/${clientName+(isDvr?"-dvr":"")}:stopRecord`,data)
    return promise;
},
startRecordGStreamer : function (data,isDvr) {
  var promise = {};
  promise = HTTP_STREAMING_RECORD.post(`v1/vhosts/default/apps/${clientName+(isDvr?"-dvr":"")}:startRecord`,data)
  return promise;
},
  
};



// WEBPACK FOOTER //
// ./src/service/index.js